import MetricsUtil from './MetricsUtil';
import initialMetricsPublisher, { makeMetricsDriver } from 'src/metrics';

const METRICS_PREFIX = 'RevCal';
const driver = makeMetricsDriver();
export default new MetricsUtil(driver, initialMetricsPublisher, METRICS_PREFIX);
